import axios from 'axios';

const baseURL =  'https://viacep.com.br'

const viacep = axios.create({
    baseURL,
    headers: {
        'Content-Type' : 'application/json'
    }
});


export default viacep;